import { BadgeBanner } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useOperatoryAvailabilityBanner } from './hooks/use-operatory-availability-state';

export const OperatoryAvailabilityBanner = () => {
  const { t } = useTranslation('schedule');
  const { isBannerDismissed, dismissBanner, signUpBanner, isOperatoryAvailabilityEnabled, viewAvailabilitySettings } =
    useOperatoryAvailabilityBanner();

  const onPrimaryActionClick = () => {
    if (isOperatoryAvailabilityEnabled) {
      viewAvailabilitySettings();
    } else {
      signUpBanner();
    }
  };

  if (isBannerDismissed) {
    return null;
  }

  return (
    <BadgeBanner styles={{ width: '100%' }}>
      <BadgeBanner.AnimatedBadge label={t('New')} />
      <BadgeBanner.Title>
        {isOperatoryAvailabilityEnabled
          ? t(
              'You now have access to Operatory Availability! Head to Availability Settings to switch “Availability Calculated By” to Operatory, then review your availability to make sure everything looks right.'
            )
          : t(
              'Operatory View is officially live! Operatory Availability is up next — sign up to be the first to try it'
            )}
      </BadgeBanner.Title>
      <Button variant='tertiary' color='primary' onClick={onPrimaryActionClick} css={{ marginLeft: 'auto' }}>
        {isOperatoryAvailabilityEnabled ? t('View Settings') : t('Sign Up')}
      </Button>
      <Button iconName='x-small' variant='secondary' onClick={dismissBanner} label={t('Dismiss')} />
    </BadgeBanner>
  );
};
